webpackJsonp([242074591378927],{

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _SEO = __webpack_require__(12);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _reactSvgInline = __webpack_require__(11);
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_React$Component) {
	    _inherits(Page, _React$Component);
	
	    function Page() {
	        _classCallCheck(this, Page);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this));
	        // this.handleSubmit = this.handleSubmit.bind(this);
	    }
	
	    // handleSubmit(e) {
	    //     e.preventDefault();
	    //
	    //     const formData = {};
	    //     for (const field in this.refs) {
	    //         if(this.refs[field].checked) {
	    //             formData[field] = this.refs[field].checked;
	    //         } else {
	    //             formData[field] = this.refs[field].value;
	    //         }
	    //     }
	    //
	    //     let toSend = {
	    //         _replyto: formData._replyto,
	    //         'Informatii Asociatie':
	    //         'Nume asociatie: ' + formData.numeAsociatie + '\n' +
	    //         'Adresa asociatie: ' + formData.adresaAsociatie + '\n' +
	    //         'Incalzire bloc: ' + formData.incalzireBloc + '\n' +
	    //         'An constructie bloc: ' + formData.anConstructieBloc + '\n' +
	    //         'Numar de apartament: ' + formData.numarDeApartamente + '\n' +
	    //         'Numar de scari: ' + formData.numarDeScari + '\n',
	    //         'Date de contact':
	    //         'Nume persoane de contact: ' + formData.numePersoanaDeContact + '\n' +
	    //         'Functie persoana de contact: ' + formData.functiePersoanaDeContact + '\n' +
	    //         'Telefon persoana de contact: ' + formData.telefonPersoanaDeContact + '\n' +
	    //         'Adresa de email: ' + formData._replyto + '\n',
	    //         'Servicii oferite':
	    //              (formData.administrareFinanciara == true ? 'Administrare financiara \n' : '') +
	    //              (formData.casierie == true ? 'Casierie \n' : '') +
	    //              (formData.administrareTehnica == true ? 'Administrare Tehnica \n' : '') +
	    //              (formData.managementDeProiect == true ? 'Management De Proiect \n' : '') +
	    //              (formData.cenzorat == true ? 'Cenzorat \n' : '')
	    //     };
	    //
	    //
	    //     const request = require('superagent');
	    //     request.post("https://formspree.io/nicad.imob@gmail.com")
	    //         .set('Content-type', 'application/json')
	    //         .set('Accept', 'application/json')
	    //         .send(toSend)
	    //         .end(() => {
	    //             document.getElementById("priceForm").reset();
	    //         });
	    // }
	
	    Page.prototype.render = function render() {
	        var pageSEO = {
	            title: "Pret administrare imobile Bucuresti",
	            description: "Primeste o oferta de pret personalizata pentru administrarea imobilului tau. Prețurile noastre se calculeaza functie de pachetul ales si de numarul de apartamente.",
	            path: "/servicii/asistenta-ssm-si-psi/"
	        };
	
	        var options = [{ value: 'one', label: 'One' }, { value: 'two', label: 'Two' }, { value: 'two', label: 'Three' }, { value: 'two', label: 'Four' }, { value: 'two', label: 'Five' }];
	
	        return _react2.default.createElement(
	            "div",
	            { className: "o-page__content" },
	            _react2.default.createElement(_SEO2.default, { pageSEO: pageSEO }),
	            _react2.default.createElement(
	                "div",
	                { className: "c-section-gradient" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "o-container u-pv-20 u-pv-30@tablet u-text-center@tablet" },
	                    _react2.default.createElement(
	                        "h1",
	                        { className: "c-page__heading" },
	                        "Preturi administrare imobile Bucuresti"
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "o-container u-pv-20 u-pv-30@tablet u-bg-white" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "o-container o-container--text u-ph-0 u-text-center" },
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        "Pre\u021Burile noastre se calculeaza functie de pachetul ales si de numarul de apartamente."
	                    ),
	                    _react2.default.createElement(
	                        "p",
	                        null,
	                        "\xCE\u021Bi po\u021Bi genera o ofert\u0103 pentru administrarea imobilului t\u0103u completand formularul de mai jos."
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "o-container o-container--offer" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "o-container o-container--large u-ph-0" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "c-offer" },
	                        _react2.default.createElement(
	                            "h2",
	                            { className: "c-offer-title" },
	                            "Genereaza o oferta personaliata"
	                        ),
	                        _react2.default.createElement(
	                            "form",
	                            { action: "https://formspree.io/nicad.imob@gmail.com",
	                                method: "POST",
	                                id: "priceForm" },
	                            _react2.default.createElement(
	                                "div",
	                                { className: "o-layout o-layout--gutter-10 c-offer-layout" },
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "o-layout__item o-layout__item--auto-size p-prices__item-1" },
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "c-box" },
	                                        _react2.default.createElement(
	                                            "h3",
	                                            { className: "c-box__title" },
	                                            "Informatii asociatie"
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "c-form__field" },
	                                            _react2.default.createElement(
	                                                "label",
	                                                { className: "c-label", htmlFor: "numeAsociatie" },
	                                                "Nume asocia\u021Bie"
	                                            ),
	                                            _react2.default.createElement("input", { className: "c-input", type: "text", name: "numeAsociatie", ref: "numeAsociatie", required: true })
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "c-form__field" },
	                                            _react2.default.createElement(
	                                                "label",
	                                                { className: "c-label", htmlFor: "adresaAsociatie" },
	                                                "Adresa asocia\u021Bie"
	                                            ),
	                                            _react2.default.createElement("input", { className: "c-input", type: "text", name: "adresaAsociatie", ref: "adresaAsociatie", required: true })
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "u-mb-05" },
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "o-layout o-layout--gutter-10" },
	                                                _react2.default.createElement(
	                                                    "div",
	                                                    { className: "o-layout__item u-1/1 u-1/2@tablet" },
	                                                    _react2.default.createElement(
	                                                        "div",
	                                                        { className: "c-form__field u-mb-0" },
	                                                        _react2.default.createElement(
	                                                            "label",
	                                                            { className: "c-label", htmlFor: "incalzireBloc" },
	                                                            "Incalzire bloc"
	                                                        ),
	                                                        _react2.default.createElement(
	                                                            "select",
	                                                            { className: "c-input c-select u-1/1", name: "incalzireBloc", ref: "incalzireBloc", required: true },
	                                                            _react2.default.createElement(
	                                                                "option",
	                                                                { value: "RADET" },
	                                                                "RADET"
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                "option",
	                                                                { value: "Centrala de bloc" },
	                                                                "Centrala de bloc"
	                                                            ),
	                                                            _react2.default.createElement(
	                                                                "option",
	                                                                { value: "Centrale de apartament" },
	                                                                "Centrale de aparatament"
	                                                            )
	                                                        )
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    "div",
	                                                    { className: "o-layout__item u-1/1 u-1/2@tablet" },
	                                                    _react2.default.createElement(
	                                                        "div",
	                                                        { className: "c-form__field u-mb-0" },
	                                                        _react2.default.createElement(
	                                                            "label",
	                                                            { className: "c-label", htmlFor: "anConstructieBloc" },
	                                                            "An constructie bloc"
	                                                        ),
	                                                        _react2.default.createElement("input", { className: "c-input", type: "number", name: "anConstructieBloc", ref: "anConstructieBloc", required: true })
	                                                    )
	                                                )
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "o-layout o-layout--gutter-10" },
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "o-layout__item u-1/1 u-1/2@tablet" },
	                                                _react2.default.createElement(
	                                                    "div",
	                                                    { className: "c-form__field" },
	                                                    _react2.default.createElement(
	                                                        "label",
	                                                        { className: "c-label", htmlFor: "numarDeApartamente" },
	                                                        "Num\u0103r de apartamente"
	                                                    ),
	                                                    _react2.default.createElement("input", { className: "c-input", type: "number", name: "numarDeApartamente", ref: "numarDeApartamente", required: true })
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "o-layout__item u-1/1 u-1/2@tablet" },
	                                                _react2.default.createElement(
	                                                    "div",
	                                                    { className: "c-form__field" },
	                                                    _react2.default.createElement(
	                                                        "label",
	                                                        { className: "c-label", htmlFor: "numarDeScari" },
	                                                        "Num\u0103r de scari"
	                                                    ),
	                                                    _react2.default.createElement("input", { className: "c-input", type: "number", name: "numarDeScari", ref: "numarDeScari", required: true })
	                                                )
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    { className: "o-layout__item o-layout__item--auto-size p-prices__item-2" },
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "c-box" },
	                                        _react2.default.createElement(
	                                            "h3",
	                                            { className: "c-box__title" },
	                                            "Date de contact"
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "c-form__field" },
	                                            _react2.default.createElement(
	                                                "label",
	                                                { className: "c-label", htmlFor: "numePersoanaDeContact" },
	                                                "Nume persoan\u0103 de contact"
	                                            ),
	                                            _react2.default.createElement("input", { className: "c-input", type: "text", name: "numePersoanaDeContact", ref: "numePersoanaDeContact", required: true })
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "c-form__field" },
	                                            _react2.default.createElement(
	                                                "label",
	                                                { className: "c-label", htmlFor: "functiePersoanaDeContact" },
	                                                "Func\u021Bie persoan\u0103 de contact"
	                                            ),
	                                            _react2.default.createElement("input", { className: "c-input", type: "text", name: "functiePersoanaDeContact", ref: "functiePersoanaDeContact", required: true })
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "c-form__field" },
	                                            _react2.default.createElement(
	                                                "label",
	                                                { className: "c-label", htmlFor: "telefonPersoanaDeContact" },
	                                                "Telefon persoan\u0103 de contact"
	                                            ),
	                                            _react2.default.createElement("input", { className: "c-input", type: "text", name: "telefonPersoanaDeContact", ref: "telefonPersoanaDeContact", required: true })
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "c-form__field" },
	                                            _react2.default.createElement(
	                                                "label",
	                                                { className: "c-label", htmlFor: "_replyto" },
	                                                "Adresa de email la care va fi trimis\u0103 oferta"
	                                            ),
	                                            _react2.default.createElement("input", { className: "c-input", type: "email", name: "_replyto", ref: "_replyto", required: true })
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    "div",
	                                    {
	                                        className: "o-layout__item o-layout__item--auto-size c-price__last p-prices__item-3" },
	                                    _react2.default.createElement(
	                                        "div",
	                                        { className: "c-box c-price__last-box" },
	                                        _react2.default.createElement(
	                                            "h3",
	                                            { className: "c-box__title" },
	                                            "Servicii dorite"
	                                        ),
	                                        _react2.default.createElement(
	                                            "div",
	                                            { className: "c-price__last-check" },
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "c-checkbox u-mb-10" },
	                                                _react2.default.createElement("input", { type: "checkbox", id: "administrareFinanciara",
	                                                    name: "administrareFinanciara", ref: "administrareFinanciara" }),
	                                                _react2.default.createElement(
	                                                    "label",
	                                                    { htmlFor: "administrareFinanciara" },
	                                                    "Administrare financiar\u0103"
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "c-checkbox u-mb-10" },
	                                                _react2.default.createElement("input", { type: "checkbox", id: "casierie", name: "Casierie", ref: "casierie" }),
	                                                _react2.default.createElement(
	                                                    "label",
	                                                    { htmlFor: "casierie" },
	                                                    "Plata numerar"
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "c-checkbox u-mb-10" },
	                                                _react2.default.createElement("input", { type: "checkbox", id: "administrareTehnica",
	                                                    name: "Administrare tehnic\u0103", ref: "administrareTehnica" }),
	                                                _react2.default.createElement(
	                                                    "label",
	                                                    { htmlFor: "administrareTehnica" },
	                                                    "Administrare tehnic\u0103"
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "c-checkbox u-mb-10" },
	                                                _react2.default.createElement("input", { type: "checkbox", id: "managementDeProiect",
	                                                    name: "Management de proiect", ref: "managementDeProiect" }),
	                                                _react2.default.createElement(
	                                                    "label",
	                                                    { htmlFor: "managementDeProiect" },
	                                                    "Management de proiect"
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "c-checkbox u-mb-0" },
	                                                _react2.default.createElement("input", { type: "checkbox", id: "cenzorat", name: "Cenzorat", ref: "cenzorat" }),
	                                                _react2.default.createElement(
	                                                    "label",
	                                                    { htmlFor: "cenzorat" },
	                                                    "Cenzorat"
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement("input", { type: "text", name: "_gotcha", style: { display: 'none' } }),
	                                    _react2.default.createElement("input", { type: "submit", className: "c-button u-mt-10", value: "Vreau oferta" })
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return Page;
	}(_react2.default.Component);
	
	exports.default = Page;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-preturi-js-39a114007199aff4f5c3.js